import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import SignupPasswordController from 'cio/pods/signup/password/controller';

export default class SignupPasswordRoute extends Route {
  setupController(controller: SignupPasswordController, model: any, transition: Transition) {
    super.setupController(controller, model, transition);
    controller.setDefaults();
  }
  model() {
    return this.modelFor('signup');
  }
}
